module.exports = __webpack_public_path__ + "static/keyword_3-e87b4f0402f4843567ce298e95bffd94.jpg";